import { combineReducers } from "@reduxjs/toolkit"
import userSessionReducer from "./userSessionReducer"
import meterListReducer from "./meterReducer"
import commandListReducer from "./commandReducer"
import GAListReducer from "./dashboard/gaListReducer"

const rootReducer = combineReducers({
  userSession: userSessionReducer,
  meterList: meterListReducer,
  commandList: commandListReducer,
  gaList: GAListReducer
})

export default rootReducer
